export default __webpack_public_path__ + "static/media/gift.6b27a745.png";